import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=58f529a5"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCloseAccent: require('/app/components/icons/IconCloseAccent.vue').default,IconSort: require('/app/components/icons/IconSort.vue').default,Input: require('/app/components/ui/input/index.js').default,IconCheck: require('/app/components/icons/IconCheck.vue').default})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
